import React,{useEffect, useState} from 'react';
import SliderCards from "../SliderCards";

function MoreProduct(props) {
    const [data, setData] = useState([])
    const [isChange, setIsChange] = useState(false)

    useEffect(() => {
        const updatedData = props.data.map(item => ({
            image: item.image,
            title: item.name,
            subTitle: item.artist.name,
            id: item.id,
        }));
        setData(updatedData);
        setIsChange(true)
    }, [props.data]);
    return (
        <div className="flex flex-col">
            <div className="flex flex-row items-center text-violet-700 font-black text-lg md:text-2xl mb-4">
                آثار بیشتر
            </div>
            <SliderCards data={data}/>
        </div>
    );
}

export default MoreProduct;